import service from '@/utils/server';

const modName='/bd/manual/weighDelivery/';
//查询结算信息
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//手工称重详情
export const details = data => {
  return service({
    url: modName + 'details',
    method: 'post',
    data
  });
};

//土地证审核通过
export const agree = data => {
  return service({
    url: modName + 'agree',
    method: 'post',
    data
  });
};

//查询未完成的手工称重订单
export const selectByPlantCodeAndVehicleNo = data => {
  return service({
    url: modName + 'selectByPlantCodeAndVehicleNo',
    method: 'post',
    data
  });
};

//创建手工称重订单
export const createWeighRecord = data => {
  return service({
    url: modName + 'createWeighRecord',
    method: 'post',
    data
  });
};

//查询称重结果
export const selectWeighValue = data => {
  return service({
    url: modName + 'selectWeighValue',
    method: 'post',
    data
  });
};

//查询采购订单带出供应商
export const selectPurchOrder = data => {
  return service({
    url: modName + 'selectPurchOrder',
    method: 'post',
    data
  });
};
//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

export const print = data => {
  return service({
    url: modName + 'print',
    method: 'post',
    data
  });
};








// WEBPACK FOOTER //
// ./src/page/bd/manualWeighDelivery/api/index.js